import { DID_CALCULATE_ROUTE } from '@/store/actions/edit_ride/ride';
import { CHANGE_ROUTE } from '@/store/actions/edit_ride/routes';

export const initialState = {
    data: [],
    index: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case DID_CALCULATE_ROUTE:
            return { ...state, data: action.data.routes };

        case CHANGE_ROUTE:
            //eslint-disable-next-line
            const { index } = action.data;
            return { ...state, index };

        default:
            return state;
    }
};
